import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Select from "react-dropdown-select";
import {
  DocumentDetailsInterface,
  RegistrationIds,
} from "../../../../assets/interface/primeSharkWebsite_interface";
import WebService from "../../../../Services/WebService";
import CompoLoader from "../../../ComponentLoader/CompoLoader";
import ErrorComponent from "../../../Common/ErrorComponent";
import HelperService from "../../../../Services/HelperService";
import UploadDocument from "../../UploadDocument/UploadDocuments";
import CommonScrollbar from "../../../Common/ScrollBar/CommonScrollbar";
import {
  getDocumentIfAvailable,
  hasAllMandatoryDocs,
} from "../../../../Services/CommonFunction";
import {
  DOCUMENT_TYPE,
  excludedDocKeys,
} from "../../../../assets/constants/constants";
import RequiredLabel from "../../../Common/RequiredLabel/RequiredLabel";
import { Button, Form } from "react-bootstrap";
import { Label } from "../../../Common/Label/Label";


interface PropsData {
  impIds: RegistrationIds;
  handleNext: any;
  from?: any;
}

const proofOfBusinessTypes = [
  {
    label: "Business Registration",
    value: "BUSINESS_REGISTRATION_CERTIFICATE",
  },
  {
    label: "Tax Identification",
    value: "TAX_IDENTIFICATION_NUMBER_CERTIFICATE",
  },
  { label: "Business License", value: "BUSINESS_LICENSE" },
  { label: "Articles of Incorporation", value: "ARTICLES_OF_INCORPORATION" },
  {
    label: "Certificate of Good Standing",
    value: "CERTIFICATE_OF_GOOD_STANDING",
  },
  { label: "Operating Agreement (LLC)", value: "OPERATING_AGREEMENT_FOR_LLC" },
  { label: "Partnership Agreement", value: "PARTNERSHIP_AGREEMENT" },
  { label: "Bank Account Statement", value: "BANK_ACCOUNT_STATEMENT" },
  {
    label: "Utility Bill (Business Name)",
    value: "UTILITY_BILL_IN_BUSINESS_NAME",
  },
  {
    label: "VAT/GST Registration Certificate",
    value: "VAT_OR_GST_REGISTRATION_CERTIFICATE",
  },
  { label: "Trade License", value: "TRADE_LICENSE" },
  { label: "Insurance Certificate", value: "INSURANCE_CERTIFICATE" },
  {
    label: "Client Contracts or Invoices",
    value: "CONTRACTS_OR_INVOICES_FROM_CLIENTS",
  },
];
const MandatoryDoc = [];

const DocumentDetails = ({ impIds, handleNext, from }: PropsData) => {
  const [documents, setDocuments] = useState<DocumentDetailsInterface[]>([]);
  const [fileLoaders, setFileLoaders] = useState<{ [key: string]: boolean }>(
    {},
  );
  const [selectedTypeOfProof, setSelectedTypeOfProof] = useState([
    { value: "", label: "Select" },
  ]);
  const [apiCallTriggered, setAPICallTriggered] = useState(false);

  const [pitchDeck, setPitchDeck] = useState(0);
  const [errorFlag, setErrorFlag] = useState(false);
  const [loader, setLoader] = useState(false);
  const [key, setKey] = useState(Math.random());
  const [proofOfBusinessUploaded, setProofOfBusinessUploaded] = useState(false);
  const [demoVideoLink, setDemoVideoLink] = useState<string>("");

  useEffect(() => {
    if (impIds && impIds?.business_uuid) {
      handleGetDocumentDetails();
    }
  }, []);

  const handleGetDocumentDetails = () => {
    setLoader(true);
    WebService.getAPI({
      action: `get-business/investment/${impIds?.business_uuid}`,
      body: null,
      isShowError: true,
    })
      .then((res: any) => {
        if (res?.status === true) {
          setDemoVideoLink(res?.info.product_demo);
          setDocuments(res?.info?.documents);
          if (res?.info?.documents?.length > 0) {
            res?.info?.documents.forEach((docu: DocumentDetailsInterface) => {
              if (docu?.type === "PITCH_DECK") {
                setPitchDeck(1);
              }
              if (!excludedDocKeys.includes(docu?.type)) {
                setSelectedTypeOfProof([
                  {
                    value: docu?.type,
                    label: HelperService.removeUnderScore(docu.type),
                  },
                ]);

                setProofOfBusinessUploaded(true);
              } else {
                setSelectedTypeOfProof([
                  {
                    value: "",
                    label: "Select",
                  },
                ]);
                setKey(Math.random());
              }
            });
          }
        }
      })
      .catch((error: any) => {
        return false;
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const uploadFile = (event: any) => {
    const selectedFiles = event.target.files;
    let maxSizeFile = false;
    Array.from(selectedFiles).map((file: any) => {
      if (file.size > 10 * 1024 * 1024) {
        maxSizeFile = true;
        toast.error("Maximum file size 10 mb");
        return;
      }
    });
    if (maxSizeFile) {
      return;
    }

    if (selectedFiles && selectedFiles.length > 0) {
      handleUploadFile(selectedFiles[0], event.target.name);

      event.target.value = null;
    }
  };

  async function handleUploadFile(file: any, type: string) {
    if (type === "") {
      toast.error("Please select type of document first");
      return;
    }
    let body = {
      type: type,
      is_pitch_deck: type === "PITCH_DECK" ? 1 : 0,
    };
    setFileLoaders((prev) => ({ ...prev, [type]: true }));
    await WebService.uploadAPI({
      action: `upload-document/investment/${impIds?.business_uuid}`,
      body: body,
      _file: file,
      key: "file",
    })
      .then((res: any) => {
        if (res?.status === true) {
          handleGetDocumentDetails();
          toast.success(res?.message);
        } else {
          toast.error(res?.message);
        }
      })
      .catch((error: any) => {
        toast.error(error?.response?.data?.message);
        return error;
      })
      .finally(() => {
        setFileLoaders((prev) => ({ ...prev, [type]: false }));
      });
  }
  const getDocumentTitle = (title: string) => {
    if (documents && documents?.length > 0) {
      let docTitle: DocumentDetailsInterface = {
        file_name: "",
        title: "",
        type: "",
        file_title: "",
        id: "",
      };
      documents.forEach((docu: DocumentDetailsInterface) => {
        if (docu?.type === title) {
          docTitle = docu;
        }
      });
      return docTitle;
    } else return null;
  };
  const handleContinue = () => {
    // if (
    //   from !== "REVIEW" &&
    //   (!proofOfBusinessUploaded )
    // ) {
    //   setErrorFlag(true);
    //   return;
    // } else if (
    //   from === "REVIEW" &&
    //   (!proofOfBusinessUploaded )
    // ) {
    //   setErrorFlag(true);
    //   return;
    // } else if (demoVideoLink) {
    //   if (demoVideoLink?.length > 250) {
    //     setErrorFlag(true);
    //     return;
    //   }
    // }
    // setErrorFlag(false);
    // if (demoVideoLink) {
    //   saveProductDemoLink();
    // } else
    if (demoVideoLink) {
      if (demoVideoLink?.length > 250) {
        setErrorFlag(true);
        return;
      } else {
        saveProductDemoLink();
      }
    } else handleNext();
  };
  const saveProductDemoLink = () => {
    WebService.addLoader("link_btn");
    setAPICallTriggered(true);
    return WebService.putAPI({
      action: `set-product-demo/${impIds?.business_uuid}`,
      body: { product_demo: demoVideoLink },
      isShowError: false,
    })
      .then((res: any) => {
        if (res?.status) {
          toast.success(res.message);
          handleNext();
        } else {
          toast.error(res.message);
        }
      })
      .catch((error: any) => {
        toast.error(error?.response?.data?.message);
        return error;
      })
      .finally(() => {
        WebService.removeLoader("link_btn");
        setAPICallTriggered(false);
      });
  };
  return (
    <>
      <div className="login-form w-100 px-0 position-relative">
        {loader ? <CompoLoader /> : null}

        <div className="custom-title my-auto font-bold mb-2">Documents</div>
        <p className="font-14 mb-1">Please upload all the documents below.</p>
        <CommonScrollbar height={"65vh"}>
          <div className="me-3">
            <RequiredLabel isRequired={false}>Business Photo</RequiredLabel>
            <UploadDocument
              type={"BUSINESS_PHOTO"}
              fileLoaders={fileLoaders}
              uploadFile={uploadFile}
              document={getDocumentIfAvailable(
                DOCUMENT_TYPE.BUSINES_PHOTO,
                documents,
              )}
              accept="image/*"
              infoCall={() => handleGetDocumentDetails()}
            />

            <ErrorComponent
              title="Please upload business photo"
              flag={errorFlag}
              isArray={false}
              data={getDocumentTitle("BUSINESS_PHOTO")?.title ?? ""}
            />
            <div className="mb-2">
              <label>Pitch-Deck</label>
              <div className="sm-text">Do you have a pitch deck</div>
              <div className="mb-3 mt-2">
                <button
                  type="button"
                  className={
                    pitchDeck === 1
                      ? "btn btn-primary me-3"
                      : "btn btn-secondary text-black me-3"
                  }
                  style={{ width: "70px" }}
                  onClick={() => setPitchDeck(1)}
                >
                  Yes
                </button>
                <button
                  type="button"
                  className={
                    pitchDeck === 1
                      ? "btn btn-secondary text-black"
                      : "btn btn-primary me-3"
                  }
                  style={{ width: "70px" }}
                  onClick={() => setPitchDeck(0)}
                >
                  No
                </button>
              </div>
              {pitchDeck === 1 && (
                <UploadDocument
                  type={"PITCH_DECK"}
                  fileLoaders={fileLoaders}
                  uploadFile={uploadFile}
                  document={getDocumentIfAvailable(
                    DOCUMENT_TYPE.PITCH_DECK,
                    documents,
                  )}
                  infoCall={() => handleGetDocumentDetails()}
                />
              )}
            </div>
            <div className="mb-2">
              <RequiredLabel isRequired={false}>Proof of Business</RequiredLabel>

              <Select
                dropdownHeight="200px"
                key={key}
                className="multi-select"
                options={proofOfBusinessTypes}
                onChange={(values: any) => {
                  if (values.length > 0) {
                    setSelectedTypeOfProof(values);
                  }
                }}
                labelField="label"
                valueField="value"
                placeholder="Select"
                name="proof"
                values={
                  from === "REVIEW"
                    ? [{ label: "Select", value: "" }]
                    : selectedTypeOfProof
                }
              />
            </div>

            <UploadDocument
              type={selectedTypeOfProof[0]?.value}
              fileLoaders={fileLoaders}
              uploadFile={uploadFile}
              documentList={documents}
              accept=".pdf, .doc, .docx, .jpg, .jpeg, .png"
              infoCall={() => handleGetDocumentDetails()}
            />
            {documents && documents?.length < 2 && (
              <ErrorComponent
                title="Please upload business proof"
                flag={errorFlag}
                isArray={false}
                data={""}
              />
            )}
            <div>
              <RequiredLabel isRequired={false}>
                Executive Summary Report
              </RequiredLabel>
              <UploadDocument
                type={DOCUMENT_TYPE?.EXECUTIVE_SUMMARY}
                fileLoaders={fileLoaders}
                uploadFile={uploadFile}
                document={getDocumentIfAvailable(
                  DOCUMENT_TYPE.EXECUTIVE_SUMMARY,
                  documents,
                )}
                infoCall={() => handleGetDocumentDetails()}
                accept=".pdf, .doc, .docx, .jpg, .jpeg, .png"
              />
            </div>
            <div>
              <RequiredLabel isRequired={false}>
                Financial Summary Report
              </RequiredLabel>
              <UploadDocument
                type={DOCUMENT_TYPE?.FINANCIAL_REPORT}
                fileLoaders={fileLoaders}
                uploadFile={uploadFile}
                document={getDocumentIfAvailable(
                  DOCUMENT_TYPE.FINANCIAL_REPORT,
                  documents,
                )}
                infoCall={() => handleGetDocumentDetails()}
                accept=".pdf, .doc, .docx, .jpg, .jpeg, .png"
              />
            </div>
            <div className="mb-3">
              <RequiredLabel isRequired={false}>
                Intro video or product demo link — YouTube or Video (max 250 char)
              </RequiredLabel>
              <Form.Control
                type="text"
                name="demoVideoLink"
                placeholder="Enter Link"
                onChange={(e: any) => {
                  setDemoVideoLink(e.target.value);
                }}
                value={demoVideoLink}
              />
              {errorFlag && demoVideoLink && demoVideoLink.length > 250 && (
                <Label
                  title="Please enter link max upto 250 char"
                  modeError={true}
                />
              )}
            </div>
            <div className="mb-2 d-flex gap-2">
              <Button
                className={
                  from === "REVIEW" || from === "FROM_PROFILE_ANALYSIS"
                    ? "btn btn-primary w-100"
                    : "btn btn-primary w-50"
                }
                type="button"
                disabled={apiCallTriggered}
                id="link_btn"
                onClick={handleContinue}
              >
                {from && from === "REVIEW" ? "Save" : "Continue"}
              </Button>
              {from !== "REVIEW" && from !== "FROM_PROFILE_ANALYSIS" && (
                <Button
                  disabled={apiCallTriggered}
                  className="btn btn-secondary w-50"
                  type="button"
                  id="skip_basic_details"
                  onClick={() => {
                    handleNext(true);
                  }}
                >
                  Skip
                </Button>
              )}
            </div>
          </div>
        </CommonScrollbar>
      </div>
    </>
  );
};
export default DocumentDetails;
